import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useErrorStore } from '../../stores/useErrorStore';
import { baseUrl, getRequest } from '../../utils/services';
import { useTicketStore } from '../../stores/useTicketStore';

export default function RedirectHandlerForAbrirChat() {
  const navigate = useNavigate();
  const location = useLocation();
  const setErrorMessage = useErrorStore((state) => state.setErrorMessage);
  const setCurrentChat = useTicketStore((s) => s.setCurrentChat);
  const removeChatFromCollections = useTicketStore((s) => s.removeChatFromCollections);

  useEffect(() => {
    const handleSetCurrentChat = async () => {
      const queryParams = new URLSearchParams(location.search);
      const sender = queryParams.get('sender');
      const fromMsg = queryParams.get('fromMsg');

      const findTicket = async (sender, fromMsg) => {
        const response = await getRequest(`${baseUrl}/chats/find/${sender}/${fromMsg}`);

        if (response.error) {
          removeChatFromCollections({ sender, fromMsg });
          setCurrentChat(null);
          setErrorMessage(
            response.code === 'RESOURCE_OUT_OF_SCOPE'
              ? response.message
              : 'Erro ao abrir chat! Entre em contato com o suporte.',
          );
          navigate('/');
          return;
        }

        return response;
      };

      if (sender && fromMsg) {
        const chatToOpen = await findTicket(sender, fromMsg);
        setCurrentChat(chatToOpen);
        navigate('/chat');
      } else {
        navigate('/');
      }
    };
    handleSetCurrentChat();
  }, [location.search, navigate, removeChatFromCollections, setCurrentChat]);

  return null;
}
